import { Box } from "@mui/material";
import { Exchange } from "../../Services/ExchangeSelectorContextProvider";
import { Label } from "./Label";
import { Uptime, UptimeIndicator } from "./UptimeIndicator";
import { isEmergencyMode } from "./emergency";

/**
 * One exchange's slot in the availability strip: its name plus its uptime dot.
 * While the exchange is in emergency mode the two become a single click target
 * for clearing that mode again.
 */
const ExchangeUptime = (props: {
  exchange: Exchange;
  uptime: Uptime;
  onClearEmergency: (exchange: Exchange) => void;
}) => {
  const { exchange, uptime, onClearEmergency } = props;
  const emergency = isEmergencyMode(uptime);
  const name = exchange.toUpperCase();

  const content = (
    <>
      <Label emergency={emergency}>{name}</Label>
      <UptimeIndicator label="" uptime={uptime} />
    </>
  );

  if (!emergency) {
    return content;
  }

  const clear = () => onClearEmergency(exchange);

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={`Clear emergency mode on ${name}`}
      onClick={clear}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          clear();
        }
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        // Matches the spacing the strip's Stack would have applied between
        // the label and the dot on their own.
        gap: 0.5,
        cursor: "pointer",
        userSelect: "none",
      }}
    >
      {content}
    </Box>
  );
};

export { ExchangeUptime };
